import Analytics from '@web/services/Analytics/Analytics'

// MOB-408: события баннера «Возникла проблема с оплатой».
// user_id подставляет сам Analytics.send — в параметры его не тащим.
interface BannerMeta { subscriptionId: number; serviceId: number }

// MOB-497: где именно показана плашка в момент события. На мобильной ширине
// у неё два состояния, и без этого параметра воронка не читается: показ есть,
// а дошёл ли пользователь до кнопок — не видно.
export type PaymentFailureBannerState = 'desktop' | 'collapsed' | 'expanded'

interface BannerMetaWithState extends BannerMeta { state: PaymentFailureBannerState }

const VIEW_SENT_PREFIX = 'paymentFailureWarning:viewSent:'

// Дедуп на сессию по подписке. После MOB-497 плашка монтируется один раз в
// App.vue и переходы переживает, так что дедуп перестал быть обязательным —
// остаётся страховкой от повторной отправки при перезагрузке SPA в той же
// вкладке. Хранилище может быть недоступно (приватный режим) — тогда дедуп
// не работает, но событие уходит: терять показ хуже, чем задвоить.
function isViewAlreadySent (subscriptionId: number): boolean {
  try {
    return Boolean(sessionStorage.getItem(`${VIEW_SENT_PREFIX}${subscriptionId}`))
  } catch {
    return false
  }
}

function markViewSent (subscriptionId: number): void {
  try {
    sessionStorage.setItem(`${VIEW_SENT_PREFIX}${subscriptionId}`, '1')
  } catch {
    // Хранилище недоступно — молча живём без дедупа.
  }
}

/** Показ баннера. Дедуплицируется на сессию по подписке — вызывать можно свободно. */
export function paymentFailureBannerView (p: BannerMetaWithState & { canReview: boolean }): void {
  if (isViewAlreadySent(p.subscriptionId)) return
  markViewSent(p.subscriptionId)
  Analytics.send({
    action: 'payment_failure_banner_view',
    subscription_id: String(p.subscriptionId),
    service_id: String(p.serviceId),
    // Показы без кнопки возврата не должны смешиваться в воронке с теми,
    // из которых возврат в принципе возможен.
    can_review: p.canReview ? '1' : '0',
    state: p.state
  })
}

export function paymentFailureBannerResumeClick (p: BannerMetaWithState): void {
  Analytics.send({
    action: 'payment_failure_banner_resume_click',
    subscription_id: String(p.subscriptionId),
    service_id: String(p.serviceId),
    state: p.state
  })
}

export function paymentFailureBannerDeclineClick (p: BannerMetaWithState): void {
  Analytics.send({
    action: 'payment_failure_banner_decline_click',
    subscription_id: String(p.subscriptionId),
    service_id: String(p.serviceId),
    state: p.state
  })
}

export function paymentFailureBannerCloseClick (p: BannerMetaWithState): void {
  Analytics.send({
    action: 'payment_failure_banner_close_click',
    subscription_id: String(p.subscriptionId),
    service_id: String(p.serviceId),
    state: p.state
  })
}
